import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { StrapiQuotationCreateBundleRequest } from '../../api/strapiCrm';
import { strapiCreateQuotationBundle } from '../../api/strapiCrm';
import { queryKeys } from '../queryKeys';

export function useCreateQuotationMutation(jwt: string | null) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data: StrapiQuotationCreateBundleRequest) => {
      if (!jwt) throw new Error('Not signed in');
      return strapiCreateQuotationBundle(jwt, data);
    },
    onSuccess: async (_, __) => {
      await qc.invalidateQueries({ queryKey: queryKeys.quotationsListPrefix(jwt) });
    },
  });
}
